import { render, staticRenderFns } from "./PricingBlock.vue?vue&type=template&id=4141305a&scoped=true&"
import script from "./PricingBlock.vue?vue&type=script&lang=js&"
export * from "./PricingBlock.vue?vue&type=script&lang=js&"
import style0 from "./PricingBlock.vue?vue&type=style&index=0&id=4141305a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141305a",
  null
  
)

export default component.exports